import date from "date-and-time";

import dates from "tools/dates";
import { DATETIME_INPUT_FORMAT, HOTEL_UTC_OFFSET } from "../constants";

function toDatetimeInput(value) {
  if (!value) return "";
  const text = String(value).replace(" ", "T").slice(0, 19);
  const hotelDate = date.addHours(new Date(text), HOTEL_UTC_OFFSET);
  return date.format(hotelDate, DATETIME_INPUT_FORMAT);
}

function toDatetimeValue(value) {
  return value ? dates.fmtDatetime2Tryton(new Date(value)) : null;
}

export { toDatetimeInput, toDatetimeValue };
